// @flow
import { error } from './common';
import * as types from '../types/students';
import type {
  STUDENTS_FETCH_STARTED_TYPE,
  STUDENTS_FETCH_SUCCEED_TYPE,
  STUDENT_FETCH_STARTED_TYPE,
  STUDENT_FETCH_SUCCEED_TYPE,
  STUDENT_SELECTED_TYPE,
  STUDENT_SELECTION_CLEARED_TYPE,
  STUDENT_DROPPED_TYPE,
  STUDENT_BOARDED_TYPE,
  STUDENT_ROUTES_UPDATED_TYPE,
  STUDENT_ROUTES_FETCH_SUCCEED_TYPE,
  STUDENT_ROUTES_FETCH_STARTED_TYPE,
  STUDENT_UNMARKED_TYPE,
  ADD_WEEKDAY_TO_STOP_TYPE,
  REMOVE_WEEKDAY_FROM_STOP_TYPE,
  FETCH_ASSIGNED_STOPS_STARTED_TYPE,
  FETCH_ASSIGNED_STOPS_SUCCESS_TYPE,
  UPDATE_STUDENT_SUCCEED_TYPE,
  UPDATE_STUDENT_STARTED_TYPE,
  SAVE_STOP_ASSIGNATIONS_STARTED_TYPE,
  SAVE_STOP_ASSIGNATIONS_SUCCEED_TYPE,
  FETCH_STUDENT_PARENTS_SUCCEED_TYPE,
  ADD_STUDENT_CHANGE_STOP_REQUESTS_TYPE,
  FETCH_STUDENT_PARENTS_STARTED_TYPE,
} from '../types/students';
import type { STUDENT_TYPE } from '../types/student';
import type { ROUTE_TYPE } from '../types/routes';
import type { PARENT_TYPE } from '../types/parents';
import type { CHANGE_STOP_REQUEST_TYPE } from '../types/changeStopRequest';
import type { GATEWAY_TYPE } from '../types/gateways';

export const startFetchStudents = (): STUDENTS_FETCH_STARTED_TYPE => ({
  type: types.STUDENTS_FETCH_STARTED,
});

export const fetchStudentsSucceed = (
  entities: {[number]: STUDENT_TYPE},
  order: Array<number>,
): STUDENTS_FETCH_SUCCEED_TYPE => ({
  type: types.STUDENTS_FETCH_SUCCEED,
  payload: {
    entities,
    order,
  },
});

export const fetchStudentsFailed = error(types.STUDENTS_FETCH_FAILED);

export const fetchStudentStarted = (id: number): STUDENT_FETCH_STARTED_TYPE => ({
  type: types.STUDENT_FETCH_STARTED,
  payload: id,
});

export const fetchStudentSucceed = (student: STUDENT_TYPE): STUDENT_FETCH_SUCCEED_TYPE => ({
  type: types.STUDENT_FETCH_SUCCEED,
  payload: student,
});

export const fetchStudentFailed = error(types.STUDENT_FETCH_FAILED);

export const selectStudent = (id: number): STUDENT_SELECTED_TYPE => ({
  type: types.STUDENT_SELECTED,
  payload: id,
});

export const deselectStudents = (): STUDENT_SELECTION_CLEARED_TYPE => ({
  type: types.STUDENT_SELECTION_CLEARED,
});

export const dropStudent = (id: number): STUDENT_DROPPED_TYPE => ({
  type: types.STUDENT_DROPPED,
  payload: id,
});

export const boardStudent = (id: number): STUDENT_BOARDED_TYPE => ({
  type: types.STUDENT_BOARDED,
  payload: {
    id,
    is_present: true,
  },
});

export const unmarkStudent = (id: number): STUDENT_UNMARKED_TYPE => ({
  type: types.STUDENT_UNMARKED,
  payload: {
    id,
    is_present: false,
  },
});

export const updateStudentStart = (changed_student: Object): UPDATE_STUDENT_STARTED_TYPE => ({
  type: types.UPDATE_STUDENT_STARTED,
  payload: changed_student,
});

export const updateStudentSuccess = (student: STUDENT_TYPE): UPDATE_STUDENT_SUCCEED_TYPE => ({
  type: types.UPDATE_STUDENT_SUCCEED,
  payload: student,
});

export const updateStudentFailed = error(types.UPDATE_STUDENT_FAILED);

export const fetchStudentRoutesStarted = (id: number): STUDENT_ROUTES_FETCH_STARTED_TYPE => ({
  type: types.STUDENT_ROUTES_FETCH_STARTED,
  payload: id,
});

export const fetchStudentRoutesSucceed = (
  id: number,
  entities: {[number]: ROUTE_TYPE},
  order: Array<number>,
): STUDENT_ROUTES_FETCH_SUCCEED_TYPE => ({
  type: types.STUDENT_ROUTES_FETCH_SUCCEED,
  payload: {
    id,
    entities,
    order,
  },
});

export const addStudentChangeStopRequests = (
  id: number,
  changeStopRequests: Array<number>,
): ADD_STUDENT_CHANGE_STOP_REQUESTS_TYPE => ({
  type: types.ADD_STUDENT_CHANGE_STOP_REQUESTS,
  payload: {
    id,
    changeStopRequests,
  },
});

export const fetchStudentParentsStarted = (id: number): FETCH_STUDENT_PARENTS_STARTED_TYPE => ({
  type: types.FETCH_STUDENT_PARENTS_STARTED,
  payload: id,
});

export const fetchStudentParentsSucceed = (
  entities: Array<PARENT_TYPE>,
  order: Array<number>,
): FETCH_STUDENT_PARENTS_SUCCEED_TYPE => ({
  type: types.FETCH_STUDENT_PARENTS_SUCCEED,
  payload: {
    entities,
    order,
  },
});

export const fetchStudentParentsFailed = error(types.FETCH_STUDENT_PARENTS_FAILED);

export const updateStudentRoutes = (
  id: number,
  entities: {[number]: ROUTE_TYPE},
  order: Array<number>,
): STUDENT_ROUTES_UPDATED_TYPE => ({
  type: types.STUDENT_ROUTES_UPDATED,
  payload: {
    id,
    entities,
    order,
  },
});

export const addWeekDayToStop = (
  weekDay: number,
  studentId: number,
  routeStopId: number,
): ADD_WEEKDAY_TO_STOP_TYPE => ({
  type: types.ADD_WEEKDAY_TO_STOP,
  payload: {
    studentId,
    weekDay,
    routeStopId,

  },
});

export const removeWeekDayFromStop = (
  weekDay: number,
  studentId: number,
  routeStopId: number,
): REMOVE_WEEKDAY_FROM_STOP_TYPE => ({
  type: types.REMOVE_WEEKDAY_FROM_STOP,
  payload: {
    studentId,
    weekDay,
    routeStopId,
  },
});

export const startFetchingAssignedStops = (
  id: number,
): FETCH_ASSIGNED_STOPS_STARTED_TYPE => ({
  type: types.FETCH_ASSIGNED_STOPS_STARTED,
  payload: {
    id,
  },
});

export const fetchAssignedStopSuccess = (stops: Object): FETCH_ASSIGNED_STOPS_SUCCESS_TYPE => ({
  type: types.FETCH_ASSIGNED_STOPS_SUCCESS,
  payload: stops,
});

export const fetchAssignedStopFailed = error(types.FETCH_ASSIGNED_STOPS_FAILED);

export const fetchStudentRoutesFailed = error(types.STUDENT_ROUTES_FETCH_FAILED);


export const startSavingRouteStopSchedule = (
  studentId: number,
  stopsSchedule: {[number]: Object},
  gatewaysSchedule: {[number]: Object},
): SAVE_STOP_ASSIGNATIONS_STARTED_TYPE => ({
  type: types.SAVE_STOP_ASSIGNATIONS_STARTED,
  payload: {
    studentId,
    stopsSchedule,
    gatewaysSchedule,
  },
});

export const fetchChangeStopRequestsStarted = (
  studentId: number,
): types.FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED_TYPE => ({
  type: types.FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED,
  payload: {
    id: studentId,
  },
});

export const fetchChangeStopRequestsSuccess = (
  entities: Array<CHANGE_STOP_REQUEST_TYPE>,
  order: Array<number>,
): types.FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS_TYPE => ({
  type: types.FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const fetchStudentGatewaysStarted = (
  studentId: number,
): types.FETCH_STUDENT_GATEWAYS_STARTED_TYPE => ({
  type: types.FETCH_STUDENT_GATEWAYS_STARTED,
  payload: studentId,
});

export const addStudentParentStarted = (
  idStudent: number,
  idParent: number,
): types.ADD_STUDENT_PARENT_STARTED_TYPE => ({
  type: types.ADD_STUDENT_PARENT_STARTED,
  payload: {
    idStudent,
    idParent,
  },
});

export const addStudentParentSuccess = (
  idStudent: number,
  parents: Array<number>,
): types.ADD_STUDENT_PARENT_SUCCESS_TYPE => ({
  type: types.ADD_STUDENT_PARENT_SUCCESS,
  payload: {
    id: idStudent,
    parents,
  },
});

export const removeStudentParentStarted = (
  idStudent: number,
  idParent: number,
): types.REMOVE_STUDENT_PARENT_STARTED_TYPE => ({
  type: types.REMOVE_STUDENT_PARENT_STARTED,
  payload: {
    idStudent,
    idParent,
  },
});

export const removeStudentParentSuccess = (
  id: number,
  parents: Array<number>,
): types.REMOVE_STUDENT_PARENT_SUCCESS_TYPE => ({
  type: types.REMOVE_STUDENT_PARENT_SUCCESS,
  payload: {
    id,
    parents,
  },
});

export const fetchStudentGatewayUserActionsSuccess = (payload: {id: number, gatewayUserActions: Array<number>}): types.FETCH_STUDENT_GATEWAYS_SUCCESS_TYPE => ({
  type: types.FETCH_STUDENT_GATEWAYS_SUCCESS,
  payload,
});

export const fetchStudentGatewaysFailed = error(types.FETCH_STUDENT_GATEWAYS_FAILED);

export const fetchChangeStopRequestFailed = error(types.FETCH_STUDENT_CHANGE_STOP_REQUESTS_FAILED);
export const removeStudentParentFailed = error(types.REMOVE_STUDENT_PARENT_FAILED);

export const saveStopAssignationSuccess = (): SAVE_STOP_ASSIGNATIONS_SUCCEED_TYPE => ({
  type: types.SAVE_STOP_ASSIGNATIONS_SUCCEED,
  payload: {},
});

export const saveStopAssignationFailed = error(types.SAVE_STOP_ASSIGNATIONS_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/students.js